// extracted by mini-css-extract-plugin
module.exports = {"promotedProduct":"promoted-product_promotedProduct__wrCf_","promotedProductImage":"promoted-product_promotedProductImage___pLC_","price":"promoted-product_price__Qunok"};